@if(question){
<div class="relative inline-block" data-dropdown-container>
    <div class="cursor-pointer" (click)="toggleDropdown($event)">
        <ng-icon class="text-blue" size="25" name="faSolidEllipsis" />

        <div [class.hidden]="!isDropdownOpen"
            class="absolute right-0 bg-background  dark:bg-background-dark rounded shadow-lg py-1 z-10">
            @if(bookmarkInfo){
            <div class="flex items-center whitespace-nowrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-background"
                (click)="bookmarkedToggled.emit()">
                @if(bookmarked){
                <ng-icon name="bootstrapJournalBookmarkFill" size="12" class="mr-2" />
                <span>Nicht mehr speichern</span>
                } @else {
                <ng-icon name="bootstrapJournalBookmark" size="12" class="mr-2" />
                <span>Speichern</span>
                }
            </div>
            }

            <div class="flex items-center whitespace-nowrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-background"
                (click)="shareQuestionModal.toggleModal()">
                <ng-icon name="faSolidShare" size="12" class="mr-2" />
                <span>Frage Teilen</span>
            </div>

            <div class="flex items-center whitespace-nowrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-background"
                (click)="feedbackComponent.toggleFeedbackModal()">
                <ng-icon name="faFlag" size="12" class="mr-2" />
                <span>Feedback geben</span>
            </div>
        </div>
    </div>
</div>

<app-feedback [question]="question"></app-feedback>
<app-modal #shareQuestionModal>
    <div class="flex flex-row items-center w-full h-full md:px-4 lg:px-12">
        <div class="flex flex-col items-center w-full text-center">
            <h3 class="pb-4">Frage Teilen</h3>
            <p class="text-center">Über den untenstehenden Link kann diese Frage direkt aufgerufen werden. Das
                funktioniert für jeden, auch für Personen die keinen Account in der App haben.</p>

            <div class="mt-10 mb-4 flex flex-col justify-center gap-4">
                <label class="inline-flex items-center answer-text cursor-pointer">
                    <input class="form-checkbox rounded-md h-6 w-6" type="checkbox" name="include_answer"
                        value="include_answer" id="include_answer" [(ngModel)]="includeAnswer"
                        (change)="onChangeOptions()" />
                    <span class="ml-2">Sofort die richtige Antwort anzeigen</span>
                </label>

                @if (orderSeed != 'public') {
                <label class="inline-flex items-center answer-text cursor-pointer">
                    <input class="form-checkbox rounded-md h-6 w-6" type="checkbox" name="include_order_seed"
                        value="include_order_seed" id="include_order_seed" [(ngModel)]="includeOrderSeed"
                        (change)="onChangeOptions()" />
                    <span class="ml-2">Antwortreihenfolge beibehalten</span>
                </label>
                }
            </div>

            <div class=" flex flex-row w-full gap-2">
                <input class="block w-full rounded border border-grey py-1.5" type="text" [value]="questionShareLink"
                    disabled>
                <button class="white-button" (click)="copyToClipboard()"><ng-icon name="faSolidCopy" /></button>
            </div>
            @if(!updated){
            <span [ngClass]="{'invisible': !copied}" class="text-green">Link in die Zwischenablage kopiert</span>
            } @else {
            <span [ngClass]="{'invisible': !copied}" class="text-green">Zwischenablage aktualisiert</span>
            }
            <button class="blue-button mt-4 w-20" (click)="close()">Fertig</button>
        </div>
    </div>
</app-modal>
}